import type { ProviderDeepLinkModel } from './providerDeepLink'

export type CampaignQuoteItemModel = {
  artwork_id?: number,
  cache_key?: number,
  campaign_quote_id?: number,
  campaign_quote_section_id?: number,
  custom_item_id?: number,
  compulsory?: boolean,
  data?: {
    default_quote_item_id?: number,
  },
  dates?: {
    required: {
      date: string,
    },
    updated: {
      integer: number,
    },
  },
  deep_link?: ProviderDeepLinkModel,
  deep_link_url?: string,
  description?: string,
  display_options?: string,
  display_title?: string,
  hidden?: boolean,
  id: number,
  internal_notes?: string,
  item_type?: 'orderable' | 'custom',
  locked?: boolean,
  options?: any,
  options_string?: string,
  order_bundle_id?: number,
  package_id?: number,
  paid_by?: 'agency' | 'agent' | 'commission' | 'vendor',
  price?: number,
  price_override?: number,
  price_type?: 'fixed' | 'percentage',
  processing_fee?: number,
  provider_id?: number,
  provider_price_list_item_id?: number,
  publication_edition_id?: number,
  publication_id?: number,
  publication_package_id?: number,
  publication_week?: number,
  quantity?: number,
  quote_total?: number,
  required_by?: string,
  row_title?: string,
  selected: boolean,
  service_id?: number,
  service_product_id?: number,
  sort?: number,
  title?: string,
  type?: 'CampaignQuoteItem',
  user_id?: number,
}

export type CampaignQuoteItemOption = {
  id: number,
  title?: string,
  value: {
    id: number,
    title?: string,
    price?: number,
    is_default?: boolean,
    is_upgrade?: boolean,
    is_downgrade?: boolean,
  },
}

export type CreateCampaignQuoteItemPayload = {
  campaign_quote_id: number,
  campaign_quote_section_id: number,
  data?: object,
  favourite_order_id?: number,
  item_type: 'orderable',
  options?: CampaignQuoteItemOption[] | string,
  package_id?: number,
  price_list_item_id?: number,
  required_by?: string | undefined,
  title: string,
}

export type CreateMultipleCampaignQuoteItemsPayload = {
  campaign_quote_id: number,
  campaign_quote_section_id: number,
  data?: object,
  item_type: 'orderable',
  options?: CampaignQuoteItemOption[],
  order_bundle_id?: number,
  price_list_item_id?: number,
  product_unlock_ids?: number[],
  publication?: {
    id: number,
  },
  publication_edition_ids?: number[],
  title?: string,
}

export type CampaignQuoteItemRequestOptions = {}

const state = {
  campaign_quote_id: undefined,
  campaign_quote_section_id: undefined,
  compulsory: false,
  custom_item_id: undefined,
  description: undefined,
  display_options: undefined,
  display_title: undefined,
  hidden: false,
  id: undefined,
  internal_notes: undefined,
  item_type: 'custom',
  locked: false,
  paid_by: 'vendor',
  price_override: undefined,
  price_type: 'fixed',
  price: undefined,
  provider_id: undefined,
  publication_edition_id: undefined,
  publication_week: undefined,
  required_by: undefined,
  row_title: undefined,
  selected: true,
  sort: undefined,
  title: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'campaign_quote_id' },
  { key: 'campaign_quote_section_id' },
  { key: 'item_type' },
  {
    key: 'price_override',
    validation: (priceOverride: string) => priceOverride !== '' && !Number.isNaN(Number(priceOverride)),
  },
  { key: 'title' },
]

export default state
